import React from 'react'
import { Link } from 'react-router-dom'
import { ManageLocalStorage } from "../../Services/Localstorage"
import { LOGOUT } from "../../Utils/Constants"
import { history } from "../../Core/Store"
import { GlobalContext, GlobalDispatchContext } from "../../Context/Context"
const UserHeaderComponent = (props) => {
    const context = React.useContext(GlobalContext)
    const topics = context.common.articleTypes
    const loginData = context.login;
    const dispatch = React.useContext(GlobalDispatchContext)
    const logout = () => {
        dispatch({
            type: LOGOUT
        })
        history.push({
            pathname: "/guest-dashboard",
        });
        window.location.reload();
        ManageLocalStorage.clear();
    }

    return (<>
        <div id="topbar" className="d-none d-lg-flex align-items-center fixed-top">
            <div className="container d-flex">
                <div className="contact-info mr-auto">
                    <i className="far fa-envelope"></i>
                    <Link to="/contact-us"> enquiry@infomed.com.my</Link>
                    {/* <a href="mailto:enquiry@infomed.com.my">enquiry@infomed.com.my</a> */}
                    <i className="fas fa-phone-alt"></i> +603 – 5613 5587
                </div>
                <div className="social-links">
                    <a href="https://twitter.com/InfoMedMagazine" target="_blank" className="twitter"><i className="fab fa-twitter"></i></a>
                    <a href="https://www.facebook.com/InfomedMalaysia/" target="_blank" className="facebook"><i className="fab fa-facebook-f"></i></a>
                    <a href="https://www.linkedin.com/company/infomed-malaysia/about/" target="_blank" className="linkedin"><i className="fab fa-linkedin-in"></i></a>
                </div>
            </div>
        </div>

        <header id="header" className="fixed-top">
            <div className="container d-flex align-items-center">
                <nav className="nav-menu navbar navbar-expand-lg navbar-light p-0">
                    <h1 className="logo mr-auto"><a href="index.html">
                        <img src="images/logo.png" alt="logo" className="headerLogo" />
                    </a>
                    </h1>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="fas fa-bars"></i>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto">
                            <li
                                className={props.history.location.pathname === "/dashboard" ||
                                    props.history.location.pathname === "/user-articles" ||
                                    props.history.location.pathname === "/view-article" ? "nav-item dropdown active" : "nav-item dropdown "}>

                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Topics</a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <ul>
                                        {topics.map((topic, i) =>
                                            <Link
                                                key={i}
                                                to={{
                                                    pathname: "/user-articles",
                                                    state: {
                                                        IdArticleType: topic.IdArticleType,
                                                        ArticleTypeName: topic.ArticleTypeName
                                                    }
                                                }}
                                            >
                                                {topic.ArticleTypeName} </Link>)}

                                    </ul>
                                </div>
                            </li>
                            <li className={props.history.location.pathname === "/read-magazine" ||
                                props.history.location.pathname === "/magazines" ? "active" : "nav-item"}>
                                <Link to={"/magazines"} className="nav-link"> Magazine/Newsletter</Link>
                            </li>
                            <li className={props.history.location.pathname === "/opinions" ||
                                props.history.location.pathname === "/view-opinion" ? "active" : "nav-item"}>
                                <Link to={"/opinions"} className="nav-link"> Opinion</Link>
                            </li>
                            <li className={props.history.location.pathname === "/videos" ? "active" : "nav-item"}>
                                <Link to={"/videos"} className="nav-link"> Videos</Link>
                            </li>
                            <li className={props.history.location.pathname === "/reports" ||
                                props.history.location.pathname === "/view-reports" ? "active" : "nav-item"}>

                                <Link to={"/reports"} className="nav-link"> Reports</Link>
                            </li>
                            <li className={props.history.location.pathname === "/user-events" ? "active" : "nav-item"}>

                                <Link to={"/user-events"} className="nav-link"> Events</Link>
                            </li>

                            <li className={props.history.location.pathname === "/services" ? "active" : "nav-item"}>
                                <Link to={"/services"} className="nav-link"> Services</Link>
                            </li>

                            <li className={props.history.location.pathname === "/products" ? "active" : "nav-item"}>
                                <Link to={"/products"} className="nav-link"> Products</Link>
                            </li>
                            {loginData.isLoggedIn ? <li className="nav-item">
                                <a className="nav-link" href="#" onClick={logout}>Logout</a>
                            </li> :
                                <li >
                                    <Link to={"/login"} className="nav-link"> Login</Link>
                                </li>
                            }
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
        <div className="header_sizebox"></div>

    </>)
}
export default UserHeaderComponent